import React from 'react'
import { Box, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import medendoLogo from '../../assets/medendo_logo.png'

interface AuthShellProps {
    children: React.ReactNode
}

// Shared outer wrapper for the auth pages (Login, Signup, SignupComplete): centers a Paper
// card with the Medendo logo on top. Each page owns its own inner Stack, since width, padding,
// and spacing differ between the multi-field forms and the single-column status page.
const AuthShell: React.FC<AuthShellProps> = ({ children }) => {
    const { t } = useTranslation()

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <Paper>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: '12px' }}>
                    <img src={medendoLogo} alt={t('common.logo_alt')} width={200} />
                </Box>
                {children}
            </Paper>
        </Box>
    )
}

export default AuthShell
